// extracted by mini-css-extract-plugin
export default {"shopping-cart-total-card":"CartTotal_shopping-cart-total-card__E3qim","indent":"CartTotal_indent__UpEig"};